import clevertap from 'clevertap-react';

export default process.env.REACT_APP_CLEVERTAP_PROJECT_ID ? clevertap : {
  event: e => e,
  initialize: e => e,
  profile: e => e
};
